export default obj => JSON.parse(JSON.stringify(obj));



// WEBPACK FOOTER //
// ./src/utils/copy-object.js